import { isValidEmail } from '@domain-group/javascript-utils'

export type ContactModel = {
  cache_key: number,
  id: number,
  address_line_1: string,
  address_line_2: string,
  address_postcode: string,
  address_region: string,
  address_state: string,
  company_name: string,
  connection_id: number,
  connection_type: string,
  contact_type: string,
  country_calling_code: string,
  email: string,
  first_name: string,
  full_name: string,
  last_name: string,
  legal_name: string,
  mailing_title: string,
  mobile: string,
  phone: string,
  salutation: string,
  title: string,
  type: 'Contact',
  user_id: number,
}

export type ContactRequestOptions = {}

const state = {
  address_line_1: '',
  address_line_2: '',
  address_postcode: '',
  address_region: '',
  address_state: '',
  company_name: '',
  connection_id: '',
  connection_type: '',
  contact_type: 'vendor',
  country_calling_code: '+61',
  email: '',
  first_name: '',
  id: null,
  last_name: '',
  legal_name: '',
  mobile: '',
  phone: '',
}

export const requiredFields = [
  { key: 'email', validation: isValidEmail, invalidMessage: 'Invalid Email format' },
  { key: 'first_name' },
  { key: 'last_name' },
]

export default state
